/* ==========================================================================
   Sticky mobile purchase bar — ported from the reference theme.

   Once the real Add button has scrolled away, the pack, the price and a
   second Add follow the customer down the page. Everything below the buy
   block — pairings, process, related products — answers a question, and the
   answer to "yes, this one" should never be a scroll back up.

   IT MIRRORS, IT DOES NOT DUPLICATE. The bar has no state of its own: the
   pack it names is read from the checked pack row every time, and its Add
   presses the real Add button, so Baseline's ProductForm keeps sole
   ownership of the add — one implementation, one set of pending and error
   states.

   Layering is handled by z-index rather than event wiring: the bar sits at
   z-40, below the menu (80), the Somm sheet (100) and the cart drawer (110),
   so any open layer covers it. Only the floating orb (35) needs to be told —
   the bar lifts it via --non-orb-lift, measured, not assumed.
   ========================================================================== */
(function () {
  'use strict';

  var bar = document.querySelector('[data-non-sticky-buy]');
  if (!bar) return;

  /* OUT OF THE SECTION, into the body. The bar renders inside the product
     section, and the reveal animations put transforms on sections — a
     transformed ancestor becomes the containing block for position:fixed,
     so the bar pinned itself to the section and scrolled away with it,
     sitting inline mid-page. Reparented to <body>, the viewport is its
     containing block again. It has no editor settings, so nothing is lost
     to the section editor by moving it. */
  if (bar.parentElement !== document.body) document.body.appendChild(bar);
  var root = document.querySelector('[data-product-root]') || document;
  var realAdd = root.querySelector('.add-to-cart');
  if (!realAdd) return;

  var packEl = bar.querySelector('[data-non-sticky-pack]');
  var priceEl = bar.querySelector('[data-non-sticky-price]');
  var addEl = bar.querySelector('[data-non-sticky-add]');

  var pastAdd = false;

  function checkedRow() {
    return root.querySelector('.non-pack-picker input:checked + .non-pack-option');
  }

  /* Read off the form, never remembered. On a single-variant product there
     are no pack rows and the product's own name and price stand in. */
  function sync() {
    var row = checkedRow();
    if (packEl) {
      var name = row && row.querySelector('.non-pack-option__name');
      packEl.textContent = name ? name.textContent.trim() : bar.getAttribute('data-fallback-pack') || '';
    }
    if (priceEl) {
      var price = row && row.querySelector('.non-pack-option__price');
      priceEl.textContent = price ? price.textContent.trim() : bar.getAttribute('data-fallback-price') || '';
    }
    if (addEl) {
      var soldOut = realAdd.disabled || realAdd.getAttribute('aria-disabled') === 'true';
      addEl.disabled = soldOut;
      addEl.textContent = soldOut
        ? bar.getAttribute('data-sold-out-label') || 'Sold out'
        : bar.getAttribute('data-add-label') || 'Add to cart';
    }
  }

  function apply() {
    bar.classList.toggle('is-on', pastAdd);
    bar.setAttribute('aria-hidden', pastAdd ? 'false' : 'true');
    /* Lift the orb clear of the bar. Measured, not assumed — the bar's height
       depends on the pack label and the safe-area inset. */
    var lift = pastAdd ? Math.round(bar.getBoundingClientRect().height) + 12 : 0;
    document.documentElement.style.setProperty('--non-orb-lift', lift + 'px');
  }

  /* The gate is a scroll position, not an IntersectionObserver — IO callbacks
     do not arrive in a tab that is not painting, which makes the bar untestable
     there. rect.bottom < 0 means "the real Add has left upwards", which is the
     real condition. Throttled with a dirty flag. */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    setTimeout(function () {
      ticking = false;
      recompute();
    }, 100);
  }

  function recompute() {
    pastAdd = realAdd.getBoundingClientRect().bottom < 0;
    apply();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  /* Pressing the bar's Add presses the real one, so loading states, error
     states and the cart drawer all behave exactly as a buy-box add. */
  if (addEl) {
    addEl.addEventListener('click', function () {
      realAdd.click();
    });
  }

  /* Pack changes arrive as radio change events from the real picker. */
  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches && event.target.matches('[data-single-option-selector]')) {
      setTimeout(sync, 0);
    }
  });

  sync();
  recompute();
})();
